import Keycloak from 'keycloak-js';
import {getUrlParameters} from '../pages/utils/UrlUtils';
;

const keycloakConfigURL = `${applicationPath}/keycloak.json`;

class AuthorizationService {

	constructor() {
		this.auth = Keycloak(keycloakConfigURL);
		this.setTokenUpdater = this.setTokenUpdater.bind(this);
	}

	setTokenUpdater() {
		setInterval(() => {
			this.auth.updateToken(10).error(() => {
				this.auth.logout({redirectUri: REDIRECT_URL});
			});
		}, 10000);
	}

}

const authorizationService = new AuthorizationService();

export default authorizationService;



// WEBPACK FOOTER //
// ./src/opencell/services/AuthorizationService.js